import { type FC } from 'react'

import { productSearchAlgoliaAccessorGetFormattedUnitQuantity } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetFormattedUnitQuantity'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

import { productSearchResultItemFactsSwitcher } from './productSearchResultItemFactsSwitcher'

export const ProductSearchResultItemFacts: FC = () => {
  const { algoliaRecord: item } = useProductSearchResultItemContext()

  const factIdSwitcher = productSearchResultItemFactsSwitcher(item)
  const formattedUnitQuantity =
    productSearchAlgoliaAccessorGetFormattedUnitQuantity(item)

  return (
    <ul className="list-disc pl-4 text-xs text-dark-primary-strong">
      {formattedUnitQuantity ? (
        <li className="text-dark-primary-max">
          {formattedUnitQuantity}{' '}
          {item.pharmaForm ? ` | ${item.pharmaForm}` : ''}
        </li>
      ) : null}

      {factIdSwitcher ? (
        <li>
          {factIdSwitcher.formattedMessage}
          {': '}
          {factIdSwitcher.value}
        </li>
      ) : null}

      {item.manufacturer ? <li>{item.manufacturer}</li> : null}
    </ul>
  )
}
